import styled from 'styled-components';

export const FileInput = styled.button`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  border: 1.3px solid #e5e5e5;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  -webkit-box-shadow: 0px 2px 2px 0px #0000000a;
  box-shadow: 0px 2px 2px 0px #0000000a;

  img {
    margin-right: 8px;
  }

  span {
    color: #555658;
    opacity: 70%;
    font: 14px Montserrat;
  }
`;

export const WrapperTagInfo = styled.div`
  margin-bottom: 24px;
`;

export const Subtitle = styled.span`
  font: 14px Montserrat;
  color: #373f45;
`;
